import { useSelector } from 'react-redux';
import React from 'react';
import { Pane, Table, Text } from 'evergreen-ui';
import { timeZoneSelector } from 'Features/App/appSlice';
import { UTCtoTimeZone } from 'Utils/UTCConverter';
import MessagesPanel from 'Features/Stations/Station/Messages/Station.Messages.Panel';
import { CHANNEL, MessagesTable } from 'Features/Stations/Station/Messages/messageUtils';
import { useGetMessageIncomingByIdQuery, useLazyGetMessageIncomingQuery } from 'Services/api/messageApi';
import SuspenseSpinner from 'Utils/SuspenseSpinner';

export default function MessagesChannel({ params, useGetStatusQuery }) {
  const { isFetching: isLoadingStatuses } = useGetStatusQuery();
  const selectedZone = useSelector(timeZoneSelector);
  const headers = React.useMemo(() => [
    { name: `Дата поступления UTC${selectedZone.selectedUserTimeZone}`, cellProps: {} },
    { name: 'Статус', cellProps: {} },
  ], [selectedZone.selectedUserTimeZone]);

  // отрисовка ЯЧЕЕК строки таблицы, т.к. на клик строки нужен обработчик, который описан в MessagesTable
  const RowCells = React.useCallback(({ message }) => {
    const { dateTime, status } = message;
    return (
      <>
        <Table.Cell>
          <Text>{dateTime ? UTCtoTimeZone(dateTime, selectedZone.selectedUserTimeZone, 'dd.MM.yyyy HH:mm:ss') : 'нет срока'}</Text>
        </Table.Cell>
        <Table.Cell>
          <Text>{status?.status}</Text>
        </Table.Cell>
      </>
    );
  }, [selectedZone.selectedUserTimeZone]);

  if (isLoadingStatuses) return <SuspenseSpinner />;

  return (
    <Pane
      display="grid"
      gridTemplateRows="max-content 1fr"
      rowGap=".5rem"
    >
      <MessagesPanel
          params={params}
          type={CHANNEL}
          useGetStatusQuery={useGetStatusQuery}
          useGetMessages={useLazyGetMessageIncomingQuery}
      />
      <MessagesTable
        type={CHANNEL}
        params={params}
        mode="table"
        headers={headers}
        RowCells={RowCells}
        useGetMessages={useLazyGetMessageIncomingQuery}
        useGetMessageFileQuery={useGetMessageIncomingByIdQuery}
      />
    </Pane>
  );
}
